import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Updated PrivateRoute to render children directly
function PrivateRoute({ children }) { 
  const { currentUser } = useAuth();
  
  // If children is not provided, or currentUser is not available, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children; // Render the children (e.g., <Profile />)
}

export default PrivateRoute;
